import React, { useState } from "react";
import styled from "styled-components";
import { Icon } from "../index";
import { KioskNavigation } from "../../../models/KioskNavigations";
import { NavigationItem } from "./NavigationItem";
import { useTranslation } from "react-i18next";

/**
 * Navigation Collapsable Main Wrapper
 */
const NavigationCollapsableWrapper = styled.li`
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 50px;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  /* min-height: 50px; */
  padding: 0 5px;
  .navigation-name {
    color: ${(theme) => theme.theme.Light3};
    margin-right: 10px;
  }
  .main-collapse {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    .collapsable-arrow {
      img {
        transition: transform 0.3s ease-in-out, opacity 0.25s ease-in-out 0.1s;
      }
    }
  }
  &.fold {
    .main-collapse {
      justify-content: center;
      .collapsable-arrow {
        display: none;
      }
    }
    .children {
      li {
        display: flex;
        justify-content: center;
      }
    }
  }
  &.unfold {
    .main-collapse {
      &.opened {
        .collapsable-arrow {
          img {
            transform: rotate(180deg);
          }
        }
        .navigation-name {
          color: ${(theme: any) => theme.theme.Light1};
        }
      }
    }
  }
  /* &:hover {
    background-color: ${(theme: any) => theme.theme.Light5};
  } */
`;

/**
 * Navigation Collapsable Children
 */
const NavigationCollapsableChildren = styled.ul`
  width: 100%;
  padding: 0;
  margin: 0;
  height: 0;
  overflow: hidden;
  transition: all 0.3s;
  &.opened {
    margin: 15px 0 0;
    height: auto;
    overflow: visible;
  }
`;
/**
 * Navigation Item Base Interface
 */
interface INavigationItem {
  navItem: KioskNavigation;
  isFold: "fold" | "unfold";
}

export const NavigationCollapsable: React.FC<INavigationItem> = ({
  navItem,
  isFold,
}) => {
  const { t } = useTranslation();
  const [menuState, setMenuState] = useState<"opened" | "closed">("closed");
  const toggleMenu = () => {
    const state = menuState === "closed" ? "opened" : "closed";
    setMenuState(state);
  };
  return (
    <NavigationCollapsableWrapper className={isFold}>
      <div
        className={"w-100 main-collapse h-100 align-items-center " + menuState}
        onClick={toggleMenu}
        style={{ minHeight: "50px" }}
      >
        <div>
          <Icon
            name={navItem.icon}
            width={navItem.width}
            height={navItem.height}
          />
          {isFold === "unfold" && (
            <span className="navigation-name">{t(navItem.translate)}</span>
          )}
        </div>
        <div className={"collapsable-arrow " + menuState} onClick={toggleMenu}>
          <Icon name={"sidearrowdown"} width={"12px"} height={"6.9px"} />
        </div>
      </div>
      <NavigationCollapsableChildren className={"children " + menuState}>
        {navItem.children &&
          navItem.children.map((item, index) => {
            if (item.type === "item") {
              return (
                <NavigationItem key={index} navItem={item} isFold={isFold} />
              );
            } else {
              return (
                <NavigationCollapsable
                  key={index}
                  navItem={item}
                  isFold={isFold}
                />
              );
            }
          })}
      </NavigationCollapsableChildren>
    </NavigationCollapsableWrapper>
  );
};
